<script setup lang="ts">
import { computed } from "vue";
import { ChartData, ChartOptions } from "chart.js/auto";
// import { useDarkModeStore } from "../../stores/dark-mode";
import Chart from "../../base-components/Chart";
import {getColor} from "@/utils/colors";
import {useColorSchemeStore} from "@/stores/color-scheme";

const props = defineProps<{
  width?: number;
  height?: number;
  total: string;
  used: string|number;
}>();

const colorScheme = computed(() => useColorSchemeStore().colorScheme);
const darkMode = false //computed(() => useDarkModeStore().darkMode);

const chartColors = () => [
  getColor("primary", 0.9),
  getColor("pending", 0.9),
  getColor("warning", 0.9),
];

const data = computed<ChartData>(() => {
  return {
    labels: ["Total", "Used"],
    datasets: [
      {
        data: [props.total, props.used],
        backgroundColor: chartColors(),
        hoverBackgroundColor:  chartColors(),
        borderWidth: 2,
        borderColor: getColor("white"),
      },
    ],
  };
});

const options = computed<ChartOptions>(() => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "83%",
  };
});
</script>

<template>
  <Chart
      type="doughnut"
      :width="props.width"
      :height="props.height"
      :data="data"
      :options="options"
  />
</template>
